// extracted by mini-css-extract-plugin
export var borderRadius = "_bi-4";
export var large = "_bi-3";
export var logoContainer = "_bi-0";
export var nameLogo = "_bi-2";
export var small = "_bi-1";